import React from 'react';
import { Box, IconButton, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

import {
  BORDER, FOCUS_RING, MUTED, SANS_STACK, SUCCESS,
} from '../common/tokens';

const SearchWrap = styled(Box)({
  position: 'relative',
  margin: '0 16px 8px',
  flexShrink: 0,
});

// The magnifier and clear button sit over the field, so the input reserves
// room for them with its own padding rather than by being wrapped in a row.
const SearchInput = styled(InputBase)({
  width: '100%',
  height: 36,
  borderRadius: 8,
  border: `1.5px solid ${BORDER}`,
  padding: '0 12px 0 34px',
  fontSize: 13,
  fontFamily: SANS_STACK,
  backgroundColor: '#fff',
  transition: 'border-color 0.15s, box-shadow 0.15s',
  '& input': { padding: 0, height: '100%' },
  '& input::placeholder': { color: MUTED, opacity: 1 },
  '&.Mui-focused': {
    borderColor: SUCCESS,
    boxShadow: FOCUS_RING,
  },
});

const SearchIconWrap = styled(Box)({
  position: 'absolute',
  left: 10,
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'inline-flex',
  color: MUTED,
  pointerEvents: 'none',
  '& svg': { fontSize: 15 },
});

const ClearButton = styled(IconButton)({
  position: 'absolute',
  right: 6,
  top: '50%',
  transform: 'translateY(-50%)',
  padding: 4,
  color: MUTED,
  '& svg': { fontSize: 14 },
});

export default function SearchField({ value, onChange, inputRef }) {
  return (
    <SearchWrap>
      <SearchIconWrap>
        <SearchIcon />
      </SearchIconWrap>
      <SearchInput
        inputRef={inputRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search your lists…"
        inputProps={{ 'aria-label': 'Search your lists' }}
      />
      {value && (
        <ClearButton
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          <CloseIcon />
        </ClearButton>
      )}
    </SearchWrap>
  );
}
